// extracted by mini-css-extract-plugin
export default {"taskCard":"TaskCard_taskCard__We+kr","cardHeader":"TaskCard_cardHeader__ZCDlz","editBtn":"TaskCard_editBtn__sWQ2d","activeCard":"TaskCard_activeCard__LN4Ef"};